import {TOPIC_CAT_SUBCAT_MWEB_CARD_STANDARDIZATION} from './experimentation-constants';

type FeatureVariantAssignmentsLike = {
    get(id: string): {configuration?: Record<string, unknown>} | undefined;
};

export interface TopicCatSubcatMwebCardStandardizationConfiguration {
    showStandardizedMobileCourseCards?: boolean;
    /** Some Tapen payloads use snake_case. */
    show_standardized_mobile_course_cards?: boolean;
}

export function isTapenConfigBooleanTrue(value: unknown): boolean {
    return value === true || value === 'true';
}

// TODO: GR-56 Remove after topic_cat_subcat_mweb_card_standardization concludes
export function isMwebStandardizedMobileCourseCardsEnabled(configuration: unknown): boolean {
    if (configuration == null || typeof configuration !== 'object') {
        return false;
    }
    const c = configuration as Record<string, unknown>;
    const raw = c.showStandardizedMobileCourseCards ?? c.show_standardized_mobile_course_cards;
    return isTapenConfigBooleanTrue(raw);
}

export function isMxMobileVerticalRecoLayoutEnabled(configuration: unknown): boolean {
    if (configuration == null || typeof configuration !== 'object') {
        return false;
    }
    const c = configuration as Record<string, unknown>;
    const raw = c.showVerticalLayout ?? c.useVerticalLayout;
    return isTapenConfigBooleanTrue(raw);
}

export const getTopicCatSubcatMwebCardStandardizationConfiguration = (
    featureVariantAssignments: FeatureVariantAssignmentsLike,
): TopicCatSubcatMwebCardStandardizationConfiguration | undefined => {
    const configuration = featureVariantAssignments.get(
        TOPIC_CAT_SUBCAT_MWEB_CARD_STANDARDIZATION,
    )?.configuration;
    return configuration as TopicCatSubcatMwebCardStandardizationConfiguration | undefined;
};

/**
 * Topic “three-card” / vertical product layout for discovery: when `TopicWrapper` passes an
 * explicit boolean, use it; otherwise derive from mweb card standardization
 * Tapen on the experimentation assignment map (e.g. tests with only ExperimentationContext).
 */
export function resolveTopicThreeCardVerticalLayoutExperiment(
    threeCardVerticalLayoutExperimentIsEnabledFromParent: boolean | undefined,
    featureVariantAssignments: FeatureVariantAssignmentsLike,
): boolean {
    if (typeof threeCardVerticalLayoutExperimentIsEnabledFromParent === 'boolean') {
        return threeCardVerticalLayoutExperimentIsEnabledFromParent;
    }
    return isMwebStandardizedMobileCourseCardsEnabled(
        getTopicCatSubcatMwebCardStandardizationConfiguration(featureVariantAssignments),
    );
}
